import { computed, shallowRef, watch, ref, type Ref } from 'vue';
import type { CallLogQuery } from '@/gql/graphql';
import type { CallAction } from '@/models/callLog';
import { googlePlaceCache } from '../address/googlePlaceCache';
import { selectedOfferPromo, isAppliedOfferedPromo } from '../operator-first-ride-offer-inventory/viewModel';

const facebookAdPhoneNumber = '+18559051142';
const miamiDadePartnershipPhoneNumber = '+18557001020';

export const currentCallLog = shallowRef<CallLogQuery['callLog'] | null>(null);
export const lastCallLog = shallowRef<CallLogQuery['callLog'] | null>(null);
export const reportCallLog = shallowRef<CallLogQuery['callLog'] | null>(null);
watch(currentCallLog, (cl) => {
  if (cl) {
    if (!reportCallLog.value || reportCallLog.value.id === cl.id) {
      // if nothing to report and we get new callLog then set it to report
      // or update existing report if same id
      reportCallLog.value = cl;
    }

    lastCallLog.value = cl;
    googlePlaceCache.value = [];
  } else {
    selectedOfferPromo.value = null;
    isAppliedOfferedPromo.value = false;
  }
});
watch(reportCallLog, (cl) => {
  if (!cl && currentCallLog.value) {
    reportCallLog.value = currentCallLog.value;
  }
});

export const isFacebookAdCall = computed(() => {
  return currentCallLog.value?.toPhoneNumber === facebookAdPhoneNumber;
});
export const isMiamiDadePartnershipCall = computed(() => {
  return currentCallLog.value?.toPhoneNumber === miamiDadePartnershipPhoneNumber;
});
export const currentCallFromPhoneNumber = computed(() => {
  return currentCallLog.value?.resolvedPhoneNumber ?? currentCallLog.value?.fromPhoneNumber;
});

export const callLogQAData: Ref<{
  operatorId?: string | null;
  customerName?: string | null;
  customerPhoneNumber: string;
  callDatetime: string;
  callLength: string;
  callRecording: string;
  operatorName?: string | null;
  callLogId: number;
  callActions: CallAction[];
} | null> = ref(null);
